import { Component, OnInit } from "@angular/core";

import { LoginService } from "../../services/login.service";

@Component({
  selector: "logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.scss"]
})
export class LogoutComponent implements OnInit {
  
  constructor(
    private loginService: LoginService,
 
  ) {}

  ngOnInit() {
    // 666
    this.loginService.logOut();
  }

}
